import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Grid, Paper, Stack, Typography, Box, Tooltip, IconButton, Button, TextField } from '@mui/material';
import { getReconcileInvoiceInitApi } from '../apiService';
import { PageLoader } from '../../../shared_elements';
import { trackActivity } from '../../../utils/mixpanel';
import moment from 'moment';
import { fieldDateFormat } from '../../../constants';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import ReconcileDetailTable from '../components/ReconcileDetailTable';
import AddCreditDebitNote from '../components/AddCreditDebitNote';
import LessMoreTextFieldComp from '../../../shared_elements/components/LessMoreTextFieldComp';
import { PermissionWrapper } from '../../../wrappers';

const ReconcileInvoiceView = () => {
    const params = useParams();
    const navigate = useNavigate()
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const [reconcileInvoiceDetail, setReconcileInvoiceDetail] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [linkedInvoice, setLinkedInvoice] = useState({ modal: false, data: null });
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        trackActivity("Page Viewed", { page_title: "Reconcile Invoice View" });
    }, []);

    useEffect(() => {
        if (!leaseBasicDetails) return;
        if (leaseBasicDetails?.status === "Draft") return;
        getInvoice();
    }, [leaseBasicDetails?.status]);

    const getInvoice = () => {
        setLoading(true);
        globalGetService(getReconcileInvoiceInitApi(params))
            .then(response => {
                if (checkApiStatus(response)) {
                    setReconcileInvoiceDetail(response.data.data);
                    setLoading(false);
                }
                setLoading(false);
            })
    }

    const onGenerateLinkedInvoice = (invoiceType) => {
        let linkedItem = {
            reconcile_id: reconcileInvoiceDetail?.id,
            invoice_number: "",
            invoice_type: invoiceType,
            currency: reconcileInvoiceDetail?.currency,
            invoice_division: "",
            to: reconcileInvoiceDetail?.to,
            invoice_items: reconcileInvoiceDetail?.invoice_items.map(item => {

                return { ...item, excess_amount:0, sub_total: Math.abs(Number(item.amount_diff_total)), tax_rate: 0, tax_amount: 0, sub_amount_total: Math.abs(Number(item.amount_diff_total)) }
            }),
            bank: reconcileInvoiceDetail?.bank,
            amount: reconcileInvoiceDetail?.amount,
            date: null,
            due_date: null,
            start_date: reconcileInvoiceDetail.start_date,
            end_date: reconcileInvoiceDetail.end_date,
            asset: reconcileInvoiceDetail?.asset,
            from: reconcileInvoiceDetail?.from,
            remarks: '',
            invoice_credit_items: reconcileInvoiceDetail?.invoice_credit_items,
            invoice_debit_items: reconcileInvoiceDetail?.invoice_debit_items
        }
        setLinkedInvoice({ modal: true, data: linkedItem })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Reconcile Invoice View`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' style={{ height: `${window.innerHeight - 135}px`, display: "flex", flexDirection: "column" }}>
                <LeasesNav />
                {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Reconcile Invoices" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                    <div className='lease-details-content' style={{ flex: 1, overflow: "auto", padding: "8px" }}>
                        <Stack spacing={2}>
                            <div >
                                <Paper className='lease-module-paper' style={{ padding: '8px', }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item size={4}>
                                            <span style={{ display: "flex", alignItems: 'center' }}>
                                                <Link to={`/lease/${params?.leaseSlug}/reconcile-invoices`} style={{ textDecoration: "none" }}> <Tooltip title="Reconcile Invoice Listing" arrow> <IconButton> <ArrowCircleLeftOutlinedIcon color="primary" /> </IconButton> </Tooltip> </Link>
                                                <div >
                                                    <Typography className='delivery-header btn-primary' color='primary'>Reconcile Invoice</Typography>
                                                </div>
                                            </span>
                                        </Grid>
                                        <Grid item size={8}>
                                            <ul className="list-inline" style={{ float: "right", alignItems: "center", display: "flex" }} >
                                                <li className='list-inline-item btn-primary' style={{ marginRight: "4px" }}>
                                                    {/* <Button size='small' variant='outlined' color='primary' endIcon={<ArrowDropDownIcon fontSize='small' />}>Export</Button> */}
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
                                                {!reconcileInvoiceDetail?.is_settle && (
                                                    <li className="list-inline-item btn-primary" style={{ marginRight: "4px" }}>
                                                        {reconcileInvoiceDetail?.is_credit_note && (
                                                            <Button size="small" variant="outlined" color="primary" onClick={() => { onGenerateLinkedInvoice({ label: 'Credit Note', value: 5 }); handleItemClicked("Raise Credit Note Button"); }} >
                                                                Raise Credit Note
                                                            </Button>
                                                        )}
                                                        {reconcileInvoiceDetail?.is_debit_note && (
                                                            <Button size="small" variant="outlined" color="primary" onClick={() => { onGenerateLinkedInvoice({ label: 'Debit Note', value: 4 }); handleItemClicked("Raise Debit Note Button") }} >
                                                                Raise Debit Note
                                                            </Button>
                                                        )}
                                                    </li>
                                                )}
                                                </PermissionWrapper>
                                                {reconcileInvoiceDetail?.is_settle && (<li className='list-inline-item btn-primary' style={{ marginRight: "4px" }}>
                                                    <Button size='small' variant='outlined' color='primary' onClick={() => { navigate(reconcileInvoiceDetail?.settle_invoice)?.(); handleItemClicked("Clicked View Settle Invoice") }}>View Settle Invoice</Button>
                                                </li>)}
                                            </ul>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="name"
                                        label="Name"
                                        variant="outlined"
                                        size='small'
                                        value={reconcileInvoiceDetail?.name ? reconcileInvoiceDetail?.name : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="start_date"
                                        label="Start Date"
                                        variant="outlined"
                                        size='small'
                                        value={reconcileInvoiceDetail?.start_date ? moment(reconcileInvoiceDetail.start_date).format(fieldDateFormat) : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="end_date"
                                        label="End Date"
                                        variant="outlined"
                                        size='small'
                                        value={reconcileInvoiceDetail?.end_date ? moment(reconcileInvoiceDetail.end_date).format(fieldDateFormat) : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="status"
                                        label="Status"
                                        variant="outlined"
                                        size='small'
                                        value={reconcileInvoiceDetail?.status ? reconcileInvoiceDetail?.status : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="invoice_type"
                                        label="Invoice Type"
                                        variant="outlined"
                                        size='small' 
                                        value={reconcileInvoiceDetail?.invoice_type === 2 ? 'Rental' : reconcileInvoiceDetail?.invoice_type === 1 ? 'Reserve' : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid size={{ md: 3, xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="currency"
                                        label="Currency"
                                        variant="outlined"
                                        size='small'
                                        value={reconcileInvoiceDetail?.currency ? reconcileInvoiceDetail?.currency?.name : ''}
                                        margin='normal'
                                        fullWidth
                                        slotProps={{ inputLabel: { shrink: true } }}
                                    />
                                </Grid>
                                <Grid item size={{ md: 12, xs: 12 }}>
                                    <LessMoreTextFieldComp label='Remarks' value={reconcileInvoiceDetail?.remarks || ""} />
                                </Grid>
                            </Grid>
                            <Box >
                                <div className="escalation-box">
                                    <ReconcileDetailTable reconcileInvoiceItems={reconcileInvoiceDetail || []} currency={reconcileInvoiceDetail?.currency?.code} getInvoice={getInvoice} />
                                </div>
                            </Box>
                            {linkedInvoice.modal ?
                                <AddCreditDebitNote
                                    leaseSlug={params?.leaseSlug}
                                    addEditInvoice={linkedInvoice}
                                    onToggleModal={() => setLinkedInvoice({ modal: false, mode: '', data: null })}
                                /> : null
                            }
                        </Stack>
                        {isLoading ? <PageLoader /> : null}
                    </div>}
            </Paper>
        </>
    )
}

export default ReconcileInvoiceView